import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=24a16d5c&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=24a16d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a16d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangxinfan/Documents/work/hqxkj/project/WSXS2025004F_平台运营服务养殖证示范化管理系统分包-水产三期/01code/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a16d5c')) {
      api.createRecord('24a16d5c', component.options)
    } else {
      api.reload('24a16d5c', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=24a16d5c&scoped=true&", function () {
      api.rerender('24a16d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading.vue"
export default component.exports